const specialities = [
    "All",
    "Family Physician",
    "Dentist",
    "Pediatrician",
    "Obstetrician/Gynecologist",
    "Cardiologist",
    "Oncologist",
    "Gastroenterologist",
    "Pulmonologist",
    "Nephrologist",
    "Endocrinologist",
    "Ophthalmologist",
    "Otolaryngologist",
    "Dermatologist",
    "Psychiatrist",
    "Neurologist",
    "Radiologist",
    "Anesthesiologist",
    "Surgeon"
]


export {specialities};